import { ErrorStateScheduleEnum } from '../error-state-schedule.enum';

export enum PanelPlansEditResolverErrorStatesEnum {
    GetPlanFailed = ErrorStateScheduleEnum.PanelPlansEditResolverErrorStatesStartIndex,
    GetPlanAvailableTriggersFailed,
    GetPlanStatusesFailed
}
